module.exports = __webpack_public_path__ + "media/images/players/GRACE_BRANDEN-6a0b5d7acee6ddc9f35b0e1d5a3ced05.png";